import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, Input, Label, Row, Col, Button} from 'reactstrap';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import './AccreditationRequestsByDomainsList.css';
import RemoveAccreditationRequestsByDomainModal from "../accreditationModal/removeAccreditationRequestsByDomainModal/RemoveAccreditationRequestsByDomainModal.container";
import EditAccreditationRequestsByDomainModal from "../accreditationModal/editAccreditationRequestsByDomainModal/EditAccreditationRequestsByDomainModal.container";
import PaginationUnreferencedAccreditationRequestsByDomains from "../../commonComponents/paginationComponent/PaginationUnreferencedAccreditationRequestsByDomains.container";
import LastRequestorsAccreditationRequestsByDomainModal from '../accreditationModal/lastRequestorsAccreditationRequestsByDomainModal/LastRequestorsAccreditationRequestsByDomainModal.container';
import ValidateDomainModal from '../accreditationModal/validateDomainModal/ValidateDomainModal.container';

const SUCCESS_MESSAGE_PATH_BY_ACTION = {
    REMOVE: 'accreditation_requests.remove_accreditation_requests_success_message',
    EDIT: 'accreditation_requests.update_accreditation_requests_success_message',
    VALIDATE: 'accreditation_requests.validate_accreditation_requests_success_message',
};

export const AVAILABLE_LIST_TYPES = {
    PENDING: 'pending',
    VALIDATED: 'validated'
};

class AccreditationRequestsByDomainsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowData: null,
            filterValue: '',
            successMessage: '',
            filtering: false
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    render() {
        return (
            <div className='accreditation-requests-by-domains-list-container'>
                <FormWrapper
                    successMessage={this.state.successMessage}>
                    <h4 className='page-label'>{_.get(this.props.translation, 'accreditation_requests.' + this.props.listType + '_accreditation_requests_by_domain_label')}</h4>
                    <PaginationUnreferencedAccreditationRequestsByDomains/>
                    {this.renderTable()}
                    <RemoveAccreditationRequestsByDomainModal data={this.state.selectedRowData}/>
                    <EditAccreditationRequestsByDomainModal data={this.state.selectedRowData}/>
                    <ValidateDomainModal data={this.state.selectedRowData} onClose={this.handleCloseModal}/>
                    <LastRequestorsAccreditationRequestsByDomainModal/>
                </FormWrapper>
            </div>
        );
    }

    renderTable = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="accreditation-requests-by-domains-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (!this.state.filtering && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="accreditation-requests-by-domains-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'accreditation_requests.' + this.props.listType + '_accreditation_requests_list_no_data_label')}</h6>
                </div>
            );
        }

        return [
            <Row className='accreditation-requests-by-domains-list-relative-header' key='relative-header'>
                <Label for='input'
                       className='relative-header-label'
                       sm={4}>{_.get(this.props.translation, 'accreditation_requests.filter_by_domain_label')}:</Label>
                <Col sm={6}>
                    <Input id={this.props.listType + '-accreditation-requests-by-domains-input'}
                           value={this.state.filterValue}
                           onChange={this.handleChangeFilterValue}
                           placeholder={_.get(this.props.translation, 'accreditation_requests.filter_by_domain_label')}/>
                </Col>
                <Col sm={2}>
                    <Button className='olive-green-btn' onClick={this.handleFilter}>
                        {_.get(this.props.translation, 'accreditation_requests.filter_label')}
                    </Button>
                </Col>
            </Row>,
            <Table className='accreditation-requests-by-domains-list-table' key='accreditation-requests-list-table'>
                <thead>
                <tr>
                    <th className='domain-th'>
                        {_.get(this.props.translation, 'accreditation_requests.organization_domain_label')}
                        <Input id='input'
                               value={this.state.filterValue}
                               onChange={this.handleChangeFilterValue}
                               onKeyDown={this.handleKeyDown}
                               onBlur={this.handleFilter}
                               className='domain-filter-input'
                               bsSize='sm'
                               placeholder={_.get(this.props.translation, 'accreditation_requests.filter_by_domain_label')}/>
                    </th>
                    <th className='number-th'>
                        {_.get(this.props.translation, 'accreditation_requests.accreditation_requests_number_label')}
                    </th>
                    <th/>
                    {this.props.listType === AVAILABLE_LIST_TYPES.PENDING ? <th/> : null}
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderAccreditationRequestsByDomainsData()}
                </tbody>
            </Table>
        ]
    };

    renderAccreditationRequestsByDomainsData = () => {
        return _.map(this.props.data, (data, index) => (
            <tr className="accreditation-requests-list-row" key={index} onClick={this.handleRowClick(data)}>
                <td className='domain-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.organization_domain_label') + ':'}>
                    <div className='td-with-icon'>
                        {data.value}
                        <IconContainer icon='create'
                                       key={data.id + '-create'}
                                       className="create-accreditation-request-icon"
                                       title={_.get(this.props.translation, 'accreditation_requests.edit_accreditation_request_label')}/>
                    </div>
                </td>
                <td className='number-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.accreditation_requests_number_label') + ':'}>
                    {data.amount}
                </td>
                <td className='last-requestors-td'>
                    <Button className="btn-sm" color="link" onClick={this.handleLastRequestorsButtonClick(data.value)}>
                        {_.get(this.props.translation, 'accreditation_requests.last_requestors_button')}
                    </Button>
                </td>
                {this.props.listType === AVAILABLE_LIST_TYPES.PENDING ? <td className='validate-link'>
                    <Button className="btn-sm" color="link" onClick={this.handleValidateButtonClick(data)}>
                        {_.get(this.props.translation, 'accreditation_requests.validate_button')}
                    </Button>
                </td> : null}
                <td className='remove-icon-td' onClick={this.handleRemoveIconClick(data)}>
                    <IconContainer icon='trash'
                                   key={data.id + '-trash'}
                                   className="trash-accreditation-request-icon"
                                   title={_.get(this.props.translation, 'accreditation_requests.remove_accreditation_request_label')}/>
                </td>
                <td className='relative-edit-icon'>
                    <IconContainer icon='create'
                                   key={data.id + '-create'}
                                   className="relative-create-accreditation-request-icon"
                                   title={_.get(this.props.translation, 'accreditation_requests.edit_accreditation_request_label')}/>
                </td>
            </tr>
        ))
    };

    handleChangeFilterValue = (e) => {
        this.setState({filterValue: e.target.value, filtering: true});
    };

    handleRowClick = (data) => () => {
        this.setState({
            selectedRowData: data,
            successMessage: _.get(this.props.translation, SUCCESS_MESSAGE_PATH_BY_ACTION.EDIT)
        });
        this.props.onAccreditationRequestsByDomainEdit();
    };

    handleRemoveIconClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({
            selectedRowData: data,
            successMessage: _.get(this.props.translation, SUCCESS_MESSAGE_PATH_BY_ACTION.REMOVE)
        });
        this.props.onAccreditationRequestsByDomainRemove();
    };

    handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.handleFilter();
        }
    };

    handleFilter = () => {
        if (!this.state.filterValue || this.state.filterValue === '') {
            this.setState({filtering: false});
        }
        this.props.onFilterByDomain(this.state.filterValue);
    };

    handleValidateButtonClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({
            selectedRowData: {
                orgDomain: data.value,
                orgName: data.orgName,
                orgCountry: data.countryCode
            },
            successMessage: _.get(this.props.translation, SUCCESS_MESSAGE_PATH_BY_ACTION.VALIDATE)
        });
        this.props.onAccreditationRequestsByDomainValidate();
    }

    handleLastRequestorsButtonClick = (domain) => (e) => {
        e.stopPropagation();
        this.props.onShowLastRequestors(domain);
    }

    handleCloseModal = () => {
        this.setState({selectedRowData: null});
    }
}

AccreditationRequestsByDomainsList.propTypes = {
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.array,
    listType: PropTypes.string,
    onMount: PropTypes.func.isRequired,
    onAccreditationRequestsByDomainRemove: PropTypes.func.isRequired,
    onAccreditationRequestsByDomainEdit: PropTypes.func.isRequired,
    onAccreditationRequestsByDomainValidate: PropTypes.func,
    onFilterByDomain: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
};

export default AccreditationRequestsByDomainsList;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationRequestsByDomainsList/AccreditationRequestsByDomainsList.js